// ─── Shared Design Tokens (Partnerships Module) ───────────────
// Re-exports the shared dt from redesignTokens so all accent colors
// respond to the user's chosen accent theme via CSS variables.

import { dt } from "../../../shared/themes/redesignTokens";

export default dt;
